module.exports = __webpack_public_path__ + "img/boticon.7fd9b135.png";